export const _state = {
    regulation: localStorage.getItem('filter_regulation') === null ? {status: [true, false, true]} : JSON.parse(localStorage.getItem('filter_regulation')),
    task: localStorage.getItem('filter_task') === null ? {status: [true, false]} : JSON.parse(localStorage.getItem('filter_task')),
};

export function filterReducer(state = _state, action) {

    switch (action.type) {

        case 'SET_FILTER_REGULATION':
            localStorage.setItem('filter_regulation', JSON.stringify(action.payload));
            return {
                ...state,
                regulation: action.payload,
            };

        case 'SET_FILTER_TASK':
            localStorage.setItem('filter_task', JSON.stringify(action.payload));
            return {
                ...state,
                task: action.payload,
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/filter.js